import HotelSettingsMyotbMyotbBaseController from 'lumen/controllers/hotel/settings/myotb/myotb-base';
import { STAGES } from 'lumen/utils/constants/otb-selfservice-constants';

export default class HotelSettingsMyotbValidationController extends HotelSettingsMyotbMyotbBaseController {
  pageName = STAGES.VALIDATING_DATA_PAGE;
}
